export default __webpack_public_path__ + "static/media/Safety_Goggles.ff68c834.svg";